import styles from "../../styles/common/Section.module.scss"

import {ReactNode} from 'react';
import clsx from "clsx";

interface SectionProps {
  extraClassName?: string;
  children: ReactNode;
}

function Section({extraClassName, children}: SectionProps) {
  return (
    <section className={clsx(styles.cSection, "c-section", extraClassName && extraClassName)}>
      {children}
    </section>
  );
}

export default Section;